import {
    FiasAddressFields,
    FiasExtendFieldsType,
    FiasSourceValue,
    ParsedExtendedFiasField,
} from "../FiasInput/Types/FiasTypes";
import { acceptHelperConvertationToValue } from "../FiasInput/Utils/Convertations/acceptConvertationHelper";
import { fiasConvertationMethods } from "../FiasInput/Utils/Convertations/Types";
import { isNotNullOrEmpty } from "../../../../../../Common/TypingUtils";

import { FiasAddress } from "./FiasAddressUtils";

function deepToLastLevel(fiasAddress: FiasAddressFields, levels: string[], helper?: fiasConvertationMethods): string {
    if (typeof fiasAddress === "string" || typeof fiasAddress === "number") {
        return acceptHelperConvertationToValue(fiasAddress, helper) || "";
    }

    const level: string = levels.shift() || "";
    if (fiasAddress.hasOwnProperty(level)) {
        // @ts-ignore
        const nextLevel: FiasAddressFields = fiasAddress[level];
        return deepToLastLevel(nextLevel, levels, helper);
    }
    return "";
}

const checkIfDependFiasApiDontExist = (fiasAddress: FiasAddressFields, level: FiasSourceValue) =>
    isNotNullOrEmpty(level.ifFiasApiDependExist) &&
    !deepToLastLevel(fiasAddress, level.ifFiasApiDependExist.split("."), level.convertationMethod);

function getFiasValueByFiasPath(fiasAddress: FiasAddressFields, valuePath: FiasSourceValue[]): string {
    return valuePath
        .reduce((acc, level) => {
            if (checkIfDependFiasApiDontExist(fiasAddress, level)) {
                return "";
            }
            if (level.autoValue) {
                return `${acc}${level.autoValue}`;
            } else if (typeof level.fiasApiPath === "string") {
                const levels = level.fiasApiPath.split(".");
                const { prefix = "", postfix = "", onValueDontExist = "" } = level;
                const extractedValue = deepToLastLevel(fiasAddress, levels, level.convertationMethod);
                if (extractedValue) {
                    if (prefix || postfix) {
                        return `${acc}${prefix}${extractedValue}${postfix}`;
                    } else {
                        return `${acc} ${extractedValue}`;
                    }
                }
                return `${acc}${onValueDontExist}`;
            }
            return acc;
        }, "")
        .trim()
        .replace(/,$/, "");
}

export function convertFiasAddressToModelAddress(
    fiasAddress: FiasAddressFields,
    extendedFields: ParsedExtendedFiasField[]
): FiasAddress {
    const result: FiasAddress = {};
    if (extendedFields?.length) {
        extendedFields.forEach(field => {
            if (!field.setToModel) {
                result[field.path] = "";
                return;
            }
            // Если в одно поле есть несколько вариантов для засечивания из api фиаса
            if (isNotNullOrEmpty(result[field.path])) {
                return;
            }
            switch (field.type) {
                case FiasExtendFieldsType.string:
                    result[field.path] = getFiasValueByFiasPath(fiasAddress, field.sourceValue);
                    break;
                case FiasExtendFieldsType.guid:
                    result[field.path] = getLastGuidFromRequest(fiasAddress, field.parentGuid);
                    break;
                case FiasExtendFieldsType.index:
                    result[field.path] = getFiasValueByFiasPath(fiasAddress, field.sourceValue);
                    break;
                case FiasExtendFieldsType.kladr:
                    result[field.path] = getKladrCodeFromRequest(fiasAddress);
                    break;
                default:
                    break;
            }
        });
    }
    return result;
}

function getLastGuidFromRequest(address: FiasAddressFields, parent?: string): string {
    let lastGuid = "";
    for (const [level, value] of Object.entries(address)) {
        if (level === parent) {
            return lastGuid;
        }
        if (value?.fiasId) {
            lastGuid = value.fiasId;
        }
    }
    return lastGuid;
}

function getKladrCodeFromRequest(address: FiasAddressFields): string {
    let kladrCode = "";
    for (const [_, value] of Object.entries(address)) {
        if (value?.code) {
            kladrCode = value.code;
        }
    }
    return kladrCode;
}
